import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = { status: null, data: [], loading: false, message: '' };

export const getQwikVoucehersAction = createAsyncThunk(
    "qwik-voucehrs",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/admin/qwik-voucehrs/${data?.page}/${data?.limit}/${data?.isDeleted}/${data.select}`)
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

const getQwikVoucehersSlice = createSlice({
    name: "qwik-voucehrs",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(getQwikVoucehersAction.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getQwikVoucehersAction.fulfilled, (state, action) => {
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            if(state.status==401){
                localStorage.clear()
              }
            state.data = Array.isArray(action.payload?.response)
                ? action.payload.response
                : [];
        });
        builder.addCase(getQwikVoucehersAction.rejected, (state, action) => {
            state.loading = false;
            state.message = action.payload?.message;
            state.status = action.payload.status_code;
            state.error = action.error.message;
        });
    },
});

export const getQwikVoucehersReducer = getQwikVoucehersSlice.reducer;
